<template>
  <div class="welcome-container">
    <div class="flex">
      <el-card class="left-col">
        <div class="title">欢迎回来，{{ userJobInfo.userName }}</div>
        <el-row style="margin-top: 40px;">
          <el-col :span="8" v-for="(item,index) in list" :key="index" style="padding-left: 30px;">
            <gameTransactionBackview :itemData="item" :key="index"></gameTransactionBackview>
          </el-col>
        </el-row>
      </el-card>
      <div class="calendar-card">
        <div class="calendar-header">
          <span class="arrow" @click="prevMonth">&lt;</span>
          <span class="year-month">{{ year }} 年 {{ month + 1 }} 月</span>
          <span class="arrow" @click="nextMonth">&gt;</span>
        </div>
        <div class="week-row">
          <span class="week-cell" v-for="(w, i) in weekDays" :key="i">{{ w }}</span>
        </div>
        <div class="date-grid">
          <div class="date-row" v-for="(row, ri) in dateRows" :key="ri">
            <span
              class="date-cell"
              v-for="(d, di) in row"
              :key="di"
              :class="{ 'other-month': d.other, 'today': d.today }"
            >{{ d.day }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-card style="margin-top: 15px;" v-if="steps.length">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">SPBCN个人赛</span>
        </el-col>
      </el-row>
      <div class="progress-steps-row">
          <div
          v-for="(step, index) in steps"
          :key="index"
          class="step-col"
          :class="{
              'step-finish': stepIndex > index,
              'step-current': stepIndex === index,
              'step-pending':stepIndex < index
          }"
          >
              <div class="step-inner" :class="{first: index === 0, last: index === steps.length - 1}">
                  <div class="step-title">
                    <i v-if="stepIndex > index" class="el-icon-success"></i>
                    <i v-if="stepIndex === index" class="el-icon-upload"></i>
                    {{ step.scheduleFlagName }}
                  </div>
                  <!-- <div class="step-desc">{{ step.desc }}</div> -->
                  <div class="step-date">{{ step.date || '未开始' }}</div>
              </div>
          </div>
      </div>
    </el-card>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">待处理流程</span>
            </el-col>
          </el-row>
          <el-empty v-if="!flowPending.length" description="暂无相关信息" :image-size="80"></el-empty>
          <div class="card card2" v-for="(item, index) in flowPending" :key="index" @click="getDetails(item.applyId, true)">
            <div class="d1">{{ item.processName }}</div>
            <div class="d2">
              <div></div>
              <el-tag type="warning" size="small" effect="dark">{{ applyStatusStr(item.flowApply.applyStatus) }}</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.createTime }}</div>
              <div class="d3">发起人：{{ item.creator }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">已处理流程</span>
            </el-col>
          </el-row>
          <el-empty v-if="!flowDone.length" description="暂无相关信息" :image-size="80"></el-empty>
          <div class="card card3" v-for="(item, index) in flowDone" :key="index" @click="getDetails(item.applyId)">
            <div class="d1">{{ item.processName }}</div>
            <div class="d2">
              <div></div>
              <el-tag type="warning" size="small" effect="dark">处理中</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.createTime }}</div>
              <div class="d3">{{ item.creator }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">我发起的流程</span>
            </el-col>
          </el-row>
          <el-empty v-if="!flowApplicant.length" description="暂无相关信息" :image-size="80"></el-empty>
          <div class="card" v-for="(item, index) in flowApplicant" :key="index" @click="getDetails(item.id)">
            <div class="d1">{{ item.flowProcessDef.processName }}</div>
            <div class="d2">
              <div></div>
              <el-tag type="primary" size="small" effect="dark">{{ applyStatusStr(item.applyStatus) }}</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.createTime }}</div>
              <div class="d3">发起人：{{ item.creator }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <!-- <el-col :span="6">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">超时流程</span>
            </el-col>
          </el-row>
          <div class="card card1" v-for="(item, index) in auditList" :key="index">
            <div class="d1">{{ item.productName }}</div>
            <div class="d2">
              <div>一级部门</div>
              <el-tag type="danger" size="small" effect="dark">已超时</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.creator }}</div>
              <div class="d3">{{ item.createTime }}</div>
            </div>
          </div>
        </el-card>
      </el-col> -->
    </el-row>
    <el-drawer
      title="审批流程"
      :size="900"
      :visible.sync="visible"
      direction="rtl">
      <div>
        <div class="t1">
          <div>{{ flowProcessDef.processName }}</div>
          <span>流程编号：{{ info.applyNo }}</span>
        </div>
        <div class="con">
          <!-- 合同内容 -->
          <el-row class="table" v-if="info.businessType === 'CONTRACT_PAYMENT'">
            <el-col :span="6">
              <div class="box">
                <div class="tit">客户名称</div>
                <div class="val">{{ contractPaymentInfo.customerName }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">合同编号</div>
                <div class="val">{{ contractPaymentInfo.contractNo }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">甲方</div>
                <div class="val">{{ contractPaymentInfo.partyA }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">乙方</div>
                <div class="val">{{ contractPaymentInfo.partyB }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">合同金额/元</div>
                <div class="val">{{ contractPaymentInfo.contractAmount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">合同状态</div>
                <div class="val">{{ contractPaymentInfo.contractStatusDesc }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">签订日期</div>
                <div class="val">{{ contractPaymentInfo.signingDate }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">缴费日期</div>
                <div class="val">{{ contractPaymentInfo.paymentDate }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">支付方式</div>
                <div class="val">{{ contractPaymentInfo.paymentMethodDesc }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">缴费类型</div>
                <div class="val">{{ contractPaymentInfo.paymentTypeDesc }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">缴费凭证</div>
                <div class="val">
                  <el-button v-if="contractPaymentInfo.paymentVoucher" type="primary" size="small" plain @click="openFn(contractPaymentInfo.paymentVoucher)">下载</el-button>
                  <span v-else>暂未上传</span>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">合同附件</div>
                <div class="val">
                  <el-button v-if="contractPaymentInfo.contractAttachment" type="primary" size="small" plain @click="openFn(contractPaymentInfo.contractAttachment)">下载</el-button>
                  <span v-else>暂未上传</span>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">发起时间</div>
                <div class="val">{{ info.createTime }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="box">
                <div class="tit">发起人</div>
                <div class="val">{{ info.applicantName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="box">
                <div class="tit">备注</div>
                <div class="val">{{ contractPaymentInfo.remark }}</div>
              </div>
            </el-col>
          </el-row>
          <!-- 审批节点 -->
          <div class="node-list">
            <div class="node" v-for="(node, i) in flowProcessDef.nodeList" :key="i">
              <div class="disc">
              </div>
              <div class="flex">
                <div class="node-name" :class="node.flowTask ? '' : 'empty'">{{ node.nodeName }}｜{{ node.approverType === 0 ? '发起人' : node.approverType === 1 ? '固定人审批' : '直属上级审批' }}</div>
                <div v-if="node.flowTask">
                  <el-tag :type="taskStatusType(node.flowTask.taskStatus)">{{ taskStatusStr(node.flowTask.taskStatus)}}</el-tag>
                </div>
              </div>

              <div class="sec" v-if="node.flowTask">
                <div class="avatar">{{ formatName(node.flowTask.approverName) }}</div>
                <div>
                  <div class="name">{{ node.flowTask.approverName }}</div>
                  <!-- 操作 -->
                  <el-button style="margin-top: 10px;" type="success" size="mini" v-if="node.flowTask.taskStatus === 0 && canOperate" @click="handleToAudit(node.flowTask.id)">去审批</el-button>
                  <!-- 已处理的记录 -->
                  <div class="desc">{{ node.flowTask.opinion }}</div>
                  <div class="files" v-if="node.flowTask.files">
                    <el-tag v-for="(file,f) in node.flowTask.fileList" :key="f" size="mini" effect="plain" class="file" @click="openFn(file)"><i class="el-icon-paperclip"></i> 附件{{ f+1 }}</el-tag>
                  </div>
                  <div class="desc" v-if="node.flowTask.operateTime">{{ node.flowTask.operateTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 审批意见弹窗 -->
    <el-dialog
      title="审批意见"
      :visible.sync="auditDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleAuditDialogClose"
    >
      <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="90px" size="small">
        <el-form-item label="审批操作" prop="action">
          <el-radio-group v-model="auditForm.action">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见" prop="opinion">
          <el-input v-model="auditForm.opinion" type="textarea" :rows="4" placeholder="请输入审批意见"></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="files">
          <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleAuditFileSuccess"
            :on-remove="handleAuditFileRemove"
            :file-list="auditFileList"
            :data="{ filePath: 'spbcn/spbcnappneed/crm/approveFile/' }"
          >
            <el-button size="small" type="primary" plain>点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="submitAudit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      stepIndex: 1,
      steps: [
        // { title: '新赛季启动', desc: '项目组', date: '2026/06/01' },
        // { title: '城市初选', desc: '品牌研发部', date: '8月-9月' },
        // { title: '城市复选', desc: '项目组', date: '9月-11月' },
        // { title: '城市决选/网络决选', desc: '设计部', date: '12月-2月' },
        // { title: '全国总决选', desc: '项目组', date: '3月-4月' }
        // { title: '确认发布', desc: '品牌研发部', date: '' }
      ],
      userJobInfo: '',
      username: window.sessionStorage.getItem('username'),
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      weekDays: ['日', '一', '二', '三', '四', '五', '六'],
      list: [
        {
          icon: 'icon-cuoqingdengji',
          title: '待处理流程',
          flag: 'product_management1',
          menuTag: '5',
          number: 0
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '已处理流程',
          flag: 'product_management1',
          menuTag: '4',
          number: 0
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '我发起的流程',
          flag: 'product_management1',
          menuTag: '8',
          number: 0
        }
        // {
        //   icon: 'icon-cuoqingdengji',
        //   title: '超时流程',
        //   flag: 'product_management1',
        //   menuTag: '6',
        //   number: 0
        // }
      ],
      auditList: [
        { productName: '2026～2027赛季SPBCN个人赛赛程信息', creator: '张三', createTime: '2026-06-01', auditStatus: 0 },
        { productName: '2026～2027赛季 ITSO团体赛', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ],
      taskStatusList: [
        { id: -2, title: '自动审批', type: 'success' },
        { id: -1, title: '发起人操作', type: '' },
        { id: 0, title: '待办', type: 'info' },
        { id: 1, title: '同意', type: 'success' },
        { id: 2, title: '驳回', type: 'danger' },
        { id: 3, title: '转交', type: 'warning' }
      ],
      flowPending: [], // 待处理列表
      applyStatusList: [], // 审批状态
      flowDone: [], // 已处理列表
      flowApplicant: [], // 我发起的列表
      info: {}, // 审批流程详情
      flowProcessDef: {},
      contractPaymentInfo: {},
      businessType: [], // 审批模版类型
      canOperate: false,
      applyId: '',
      taskId: '',
      // 审批意见弹窗
      auditDialogVisible: false,
      auditLoading: false,
      auditForm: {
        action: 1,
        files: [],
        opinion: ''
      },
      auditFileList: [],
      auditRules: {
        action: [{ required: true, message: '请选择审批操作', trigger: 'change' }],
        opinion: [{ required: true, message: '请输入审批意见', trigger: 'blur' }]
      },
      uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
      uploadHeaders: { Authorization: localStorage.getItem('Authorization') }
    }
  },
  computed: {
    dateRows () {
      const firstDay = new Date(this.year, this.month, 1).getDay()
      const daysInMonth = new Date(this.year, this.month + 1, 0).getDate()
      const daysInPrev = new Date(this.year, this.month, 0).getDate()
      const now = new Date()
      const rows = []
      let row = []
      // 上月补位
      for (let i = firstDay - 1; i >= 0; i--) {
        row.push({ day: daysInPrev - i, other: true, today: false })
      }
      // 当月
      for (let d = 1; d <= daysInMonth; d++) {
        const isToday = this.year === now.getFullYear() && this.month === now.getMonth() && d === now.getDate()
        row.push({ day: d, other: false, today: isToday })
        if (row.length === 7) {
          rows.push(row)
          row = []
        }
      }
      // 下月补位
      let next = 1
      while (row.length < 7) {
        row.push({ day: next++, other: true, today: false })
      }
      if (row.length > 0) rows.push(row)
      return rows
    }
  },
  created () {
    this.$store.commit('SET_ACTIVE_MENU_ID', '')
    this.$store.commit('SET_ACTIVE_TOP_MENU_ID', '')
    this.$store.commit('SET_TOP_MENUS', [])
    this.userJobInfo = this.$store.state.userJobInfo
    // console.log(this.userJobInfo)
    this.getTabList()
    this.getApplyStatus()
    this.refreshList()
    // this.getBusinessType()
  },
  methods: {
    refreshList () {
      this.getFlowPending()
      this.getFlowApplicant()
      this.getFlowDone()
    },
    handleToAudit (taskId) {
      this.taskId = taskId
      this.auditForm = { action: 1, files: [], opinion: '' }
      this.auditFileList = []
      this.auditDialogVisible = true
      this.$nextTick(() => {
        this.$refs.auditFormRef && this.$refs.auditFormRef.clearValidate()
      })
    },
    handleAuditFileSuccess (res) {
      if (res.code === 200 && res.data) {
        this.auditForm.files.push(res.data)
      } else {
        this.$message.error((res && res.msg) || '上传失败')
      }
    },
    handleAuditFileRemove (file) {
      const url = file.url || (file.response && file.response.data)
      this.auditForm.files = this.auditForm.files.filter(item => item !== url)
    },
    handleAuditDialogClose () {
      this.auditForm = { action: 1, files: [], opinion: '' }
      this.auditFileList = []
    },
    submitAudit () {
      this.$refs.auditFormRef.validate((valid) => {
        if (!valid) return
        this.auditLoading = true
        const params = {
          action: this.auditForm.action,
          files: JSON.stringify(this.auditForm.files),
          opinion: this.auditForm.opinion,
          taskId: this.taskId
        }
        this.$http.post('flow/approve', params).then((res) => {
          if (res.code === 200) {
            this.$message.success('审批成功')
            this.auditLoading = false
            this.auditDialogVisible = false
            // 刷新审批详情
            this.getDetails(this.applyId, false)
            // 关闭抽屉并刷新列表
            this.visible = false
            this.refreshList()
          } else {
            this.auditLoading = false
            this.$message.error(res.msg || '审批失败')
          }
        }).catch(() => {
          this.auditLoading = false
          this.$message.error('审批失败')
        })
      })
    },
    openFn (url) {
      window.open(url)
    },
    getBusinessType () {
      this.$http.get('flow/def/businessTypeList').then(res => {
        if (res.code === 200) {
          this.businessType = res.data
        }
      })
    },
    getApplyStatus () {
      this.$http.get('/flow/applyStatusEnums').then(res => {
        if (res.code === 200) {
          this.applyStatusList = res.data
        }
      })
    },
    getFlowPending () {
      this.$http.get('flow/pending?pageNum=1&pageSize=200').then(res => {
        if (res.code === 200) {
          this.flowPending = res.data.list
          this.list[0].number = res.data.total
        }
      })
    },
    getFlowApplicant () {
      this.$http.get('flow/applicant?pageNum=1&pageSize=200').then(res => {
        if (res.code === 200) {
          this.flowApplicant = res.data.list
          this.list[2].number = res.data.total
        }
      })
    },
    getFlowDone () {
      this.$http.get('flow/done?pageNum=1&pageSize=200').then(res => {
        if (res.code === 200) {
          this.flowDone = res.data.list
          this.list[1].number = res.data.total
        }
      })
    },
    applyStatusStr (status) {
      return this.applyStatusList.find(item => item.code === status).desc
    },
    getDetails (applyId, canOperate) {
      this.applyId = applyId
      this.canOperate = canOperate
      this.$http.get(`flow/info/${applyId}`).then(res => {
        if (res.code === 200) {
          this.visible = true
          this.info = res.data
          this.flowProcessDef = res.data.flowProcessDef
          this.flowProcessDef.nodeList.forEach(item => {
            if (item.flowTask && item.flowTask.files) {
              item.flowTask.fileList = JSON.parse(item.flowTask.files)
            }
          })
          this.contractPaymentInfo = res.data.contractPaymentInfo
        }
      })
    },
    formatName (str) {
      return str.slice(0, 1)
    },
    taskStatusType (status) {
      return this.taskStatusList.find(item => item.id === status).type
    },
    taskStatusStr (status) {
      return this.taskStatusList.find(item => item.id === status).title
    },
    prevMonth () {
      if (this.month === 0) { this.year--; this.month = 11 } else { this.month-- }
    },
    nextMonth () {
      if (this.month === 11) { this.year++; this.month = 0 } else { this.month++ }
    },
    getTabList () {
      this.$http.get('seasonProduct/selectnewtSeasonScheduleBySeason/SPBCN').then(res => {
        if (res.code === 200) {
          res.data.forEach((item, index) => {
            item.date = index === 0 ? item.beginTime : `${item.beginTime} ~ ${item.endTime}`
          })
          this.steps = res.data
          // this.startTime = res.data[0].beginTime
          // this.scheduleList = (res.data || []).filter((item, index) => index !== 0).map(item => ({
          //   beginTime: item.beginTime || '',
          //   endTime: item.endTime || '',
          //   id: item.id || '',
          //   price: item.price || '',
          //   scheduleFlagName: item.scheduleFlagName
          // }))
          // this.currentIndex = res.data.findIndex(item => item.starting)
          // this.chooseIndex = this.currentIndex
          // this.currentTabObj = res.data.find(item => item.starting)
          // const flag = res.data.find(item => item.starting).scheduleFlag
          // this.getDept(flag)
          // if (flag === 'START') {
          //   this.selectStartInfo()
          // }
          // this.chooseFlag = this.steps[this.chooseIndex].scheduleFlag
          // this.getTimeLine()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bg {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/newerp_icon1.png);
  background-size: auto 90%;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
  position: absolute;
  top: 0;
  right: 0;
}
.txt {
  font-size: 60px;
  font-weight: 600;
  color: #464545;
  padding-bottom: 120px;
}
.h1 {
  font-weight: 400;
  font-size: 40px;
  color: #464545;
  margin-bottom: 20px;
}
.row {
  width: 800px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.flex{
  display: flex;
}
.left-col{
  flex: 1;
  margin-right: 15px;
}
.calendar-card {
  width: 340px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  padding: 16px;
  z-index: 10;
}
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.year-month {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.arrow {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  padding: 0 8px;
  user-select: none;
}
.arrow:hover {
  color: #409eff;
}
.week-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 6px;
}
.week-cell {
  font-size: 12px;
  color: #909399;
  height: 32px;
  line-height: 32px;
}
.date-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.date-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
}
.date-cell {
  font-size: 13px;
  color: #303133;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  cursor: default;
}
.date-cell.other-month {
  color: #c0c4cc;
}
.date-cell.today {
  background: #409eff;
  color: #fff;
  font-weight: bold;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: 0 auto;
}
.title{
  color: #000;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.card{
  margin-bottom: 20px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,.15);
  background-image: linear-gradient(to right, rgba(64, 150, 255, .5), #fff);
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  &:hover{
    box-shadow: 0 4px 10px 0 rgba(0,0,0,.25);
  }
  .d1{
    font-size: 14px;
    font-weight: bold;
  }
  .d2{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #000;
  }
  .d3{
    font-size: 12px;
    font-weight: bold;
    color: #666;
    line-height: 20px;
    margin-top: 4px;
  }
}
.card1{
  background-image: linear-gradient(to right, rgba(245, 108, 108, .5), #fff);
}
.card2{
  background-image: linear-gradient(to right, rgba(230, 162, 60, .5), #fff);
}
.card3{
  background-image: linear-gradient(to right, rgb(193, 248, 165, .5), #fff);
}

.progress-steps-row {
    display: flex;
    width: 100%;
  }

  .step-col {
    flex: 1;
    position: relative;
    // 卡片之间留空隙
    &:not(:first-child) {
      margin-left: -5px;
    }

    .step-inner {
      background: #E9E9EB;
      padding: 10px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    // ========= Step 标签 =========
    .step-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .step-label {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 6px;

      .step-label-text {
        font-size: 15px;
        color: #909399;
        font-weight: 600;
      }
      .step-label-check {
        font-size: 14px;
        color: #36b34a;
        font-weight: bold;
      }
    }

    // ========= 第一个：左直边，右侧向外斜凸（尖角朝右） =========
    .step-inner.first {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%
      );
    }

    // ========= 中间区块：【左侧向外凸、右侧向外凸】斜边完全平行！重点修复 =========
    .step-inner:not(.first):not(.last) {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%,
        16px 50%
      );
    }

    // ========= 最后一块：左侧向外凸，右直边 =========
    .step-inner.last {
      clip-path: polygon(
        0 0,
        100% 0,
        100% 100%,
        0 100%,
        16px 50%
      );
    }

    .step-circle {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      background: #c0c4cc;
      margin-bottom: 8px;
      flex-shrink: 0;
      margin-left: 5px;
    }

    .step-title {
      font-size: 15px;
      color: #303133;
      font-weight: 500;
      margin-bottom: 4px;
      line-height: 1.4;
    }
    .step-desc {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
    }
    .step-date{
      font-size: 10px;
      color: #666;
    }

    // 状态颜色
    &.step-finish {
      .step-title {
        color: #000;
      }
      .step-inner{
        background-color: #f9d64a;
      }
    }
    &.step-current {
      .step-title {
        color: #1A2B4C;
        font-weight: bold;
      }
      .step-inner{
        background: linear-gradient(140deg, #f9d64a, #fdf4ce);
      }
    }
    &.step-pending {
      .step-title {
        color: #777;
      }
      .step-desc {
        color: #909399;
      }
    }
  }

.t1{
  background-image: linear-gradient(140deg, #aeb6fe, #fff);
  color: #000;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 36px;
  line-height: 36px;
  span{
    color: #666;
    font-size: 12px;
    font-weight: 400;
  }
}
.con{
  padding: 20px;
}
.table{
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}
.box{
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  height: 78px;
  padding: 10px;
  box-sizing: border-box;
  .tit{
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
  }
  .val{
    font-size: 14px;
    color: #000;
    span{
      font-size: 12px;
      color: #333;
    }
  }
}
.node-list{
  margin-top: 20px;
  .node{
    padding-bottom: 10px;
    padding-left: 20px;
    position: relative;
    height: fit-content;
    .node-name{
      color: #fff;
      background-color: #3F50F0;
      padding: 0 14px;
      width: fit-content;
      height: 30px;
      line-height: 30px;
      margin-right: 20px;
      font-size: 12px;
      font-weight: bold;
    }
    .empty{
      background-color: #CCCCCC;
    }
    .disc{
      width: 6px;
      height: 6px;
      border-radius: 6px;
      border: 2px solid #3F50F0;
      background-color: #fff;
      position: absolute;
      left: 0px;
      top: 12px;
    }
    &::before{
      display: block;
      content: '';
      width: 2px;
      height: 100%;
      background-color: #c0c6fe;
      position: absolute;
      left: 4px;
      top: 14px;
    }
  }
}
.sec{
  display: flex;
  margin-top: 14px;
  min-height: 80px;
}
.avatar{
  width: 34px;
  height: 34px;
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  background-color: #F9D64B;
}
.name{
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
}
.desc{
  color: #666;
  font-size: 12px;
  margin: 8px 0;
}
.file{
  cursor: pointer;
  margin-right: 8px;
}
</style>
